<template>
    <div class="sales">
        <div v-if="isLoaded" class="row">
            <template v-if="sales.length > 0">
                <b-list-group class="col-6">
                    <b-list-group-item
                        v-for="(salesPerson,code) in sales"
                        :key="code"
                        :class="{ 'active': code === selectedSales }"
                        @click="selectedSales = code">
                        <strong>{{ salesPerson.code }}</strong><br>{{ salesPerson.name }}
                    </b-list-group-item>
                </b-list-group>

                <b-card
                    v-if="selectedSales || selectedSales === 0"
                    class="col-6"
                    :title="sales[selectedSales].name"
                >
                    <b-card-text>
                        <p><font-awesome-icon icon="phone"/> {{ sales[selectedSales].phone }}</p>
                        <p><font-awesome-icon icon="envelope"/> {{ sales[selectedSales].email }}</p>

                        <div
                            class="form-group row w-100"
                            v-for="(setting, index) in selectedSalesData.settings"
                            :key="index"
                        >
                            <label class="col-9 col-md-10 col-form-label">
                                {{ $t('manager.company.sales.settings.' + index) }}
                            </label>
                            <div class="col-3 col-md-2">
                                <div class="form-check">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        v-model="selectedSalesData.settings[index]"
                                    >
                                </div>
                            </div>
                        </div>

                        <file-uploader
                            :backendId="backendId"
                            :for="'sales-' + sales[selectedSales].code"
                            :filename="sales[selectedSales].picture"
                            resolution="500x500">
                        </file-uploader>

                        <button class="btn btn-default" @click.prevent="updateChanges">{{ $t("save") | capitalize-first }}</button>
                    </b-card-text>
                </b-card>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
        </div>
        <div v-else class="offer m-3 p-3 border rounded">
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </div>
    </div>
</template>

<script>
import FileUploader from './utilities/FileUploader.vue'
import axios from 'axios'

export default {
  name: 'SalesList',
  data () {
    return {
      isLoaded: false,
      sales: {},
      selectedSales: null
    }
  },
  props: {
    backendId: String
  },
  components: {
    FileUploader
  },
  computed: {
    selectedSalesData () {
      return this.sales[this.selectedSales]
    }
  },
  methods: {
    loadSalesList: function () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getSalesList.php?backendId=' + this.backendId, {
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
        .then(function (response) {
          me.sales = response.data
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    updateChanges () {
      // eslint-disable-next-line
      console.log('Updating changes to sales')
      let me = this
      let obj = { ...me.sales[me.selectedSales], backendId: me.backendId }
      axios.post(me.$store.getters.urlPath + 'services/manager/saveSalesData.php', obj)
        .then((response) => {
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  mounted () {
    this.loadSalesList()
  }
}
</script>

<style lang="scss">
.sales {
    width: 100%;

    .list-group-item:hover {
        cursor: pointer;
    }
}
</style>
